import { isEmpty } from "lodash-es"

// 사업자 등록번호
export const isComNum = (val) => {
  return isEmpty(val) || (restoreComNum(val).length === 10)
}

export const transformComNum = (val) => {
  if (!val) return val
  const _val = restoreComNum(val).slice(0, 10)
  return _val.replace(/[^0-9]/g, "").replace(/([0-9]{3})([0-9]{2})?([0-9]+)$/, "$1-$2-$3").replace("--", "-")
}

export const restoreComNum = (val) => {
  if (!val) return val
  return val.replace(/[^0-9]/g, "").replace(/[-]/g, "")
}